module.exports = __webpack_public_path__ + "img/dl (2).9aee483e.jpg";